namespace GeniuzPOS.Inventory {
    export class IcStockApproveSetAssembleColumns {
        static columnsKey = 'Inventory.IcStockApproveSetAssemble';
    }
}
